<script>
import moment from "moment";
import {
  MapGender,
  MapRoles,
  MapVisionDisease,
  MapEyeType,
  MapTreatmentStage,
  MapEyeAcuityLogmar,
} from "@/common/util";
import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";

import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer,
  },
  data() {
    const ROLE_GROUP_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_GROUP_OPTOMETRIST") > -1;
    const ROLE_AGENT_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1 ||
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
    const ROLE_DOCTOR =
      localStorage.getItem("roles").indexOf("ROLE_DOCTOR") > -1;


    let stationId = this.$cookie.get("stationId");
    let salesPromotionArr = [{label: '', keyName: ''}];

    const validateMobile = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      setTimeout(async () => {
        if (!/^1(3|5|6|7|8|9)\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          const test = await this.checkUserPhone();
          if (test) {
            if (test.stationId === this.stationId) {
              this.importUserAlertSameStation = true;
            } else {
              this.tempExistUserInfo = test;
              this.importUserAlertNewStation = true;
            }
          } else {
            callback();
          }
        }
      }, 1000);
    };
    const activePageNumber = sessionStorage.getItem("activePageNumber") || 1;
    // console.log('???activePageNumber', activePageNumber)
    const activePageTab = sessionStorage.getItem("activePageTab") || "ALL";
    const unitPrice = parseInt(this.$cookie.get("stationCoursePrice"));
    let searchFormData = {
      name: undefined,
      phone: undefined,
      remindNumber: undefined,
      courseConfigured: undefined,
      treatmentStage: undefined,
      trainingEnabled: "true",
      remark: "",
    };
    let activeSerachArray = [
      {
        label: "姓名",
        keyName: "name",
        type: "text",
      },
      {
        label: "手机号",
        keyName: "phone",
        type: "text",
      },
      {
        label: "剩余训练项<(小于)",
        keyName: "remindNumber",
        type: "number",
      },
      {
        label: "备注",
        keyName: "remark",
        type: "text",
      },
      {
        label: "待配置",
        keyName: "courseConfigured",
        type: "checkbox",
      },
    ];
    let OptSearchArray = [
        {
          label: "省市搜索",
          keyName: "provinceCity",
          children: [],
          type: "cascader"
        },
        {
          label: "医疗机构",
          keyName: "stationId",
          type: "select",
          value: "",
          children: []
        },
      {
        label: "训练阶段",
        keyName: "treatmentStage",
        type: "radio",
        value: "",
        children: [
          {
            label: "全部",
            keyName: "",
          },
          {
            label: "提升",
            keyName: "PROMOTE",
          },
          {
            label: "巩固",
            keyName: "CONSOLIDATION",
          },
        ],
      },
      {
        label: "训练状态",
        keyName: "trainingEnabled",
        type: "radio",
        value: "true",
        children: [
          {
            label: "全部",
            keyName: "",
          },
          {
            label: "开启",
            keyName: "true",
          },
          {
            label: "关闭",
            keyName: "false",
          },
        ],
      },
    ];
    if (sessionStorage.getItem("patientManagementsearchFormData")) {
      searchFormData = JSON.parse(
        sessionStorage.getItem("patientManagementsearchFormData")
      );
      activeSerachArray.forEach((item) => {
        if (searchFormData[item.keyName]) {
          item.value = searchFormData[item.keyName];
        }
      });
      OptSearchArray.forEach((item) => {
        if (searchFormData[item.keyName]) {
          item.value = searchFormData[item.keyName];
        }
      });
    }

    return {
      tableData: [],
      stationId,
      ProvinceList: [],
      salesPromotionArr,
      totalElements: 0,
      activeSerachArray: activeSerachArray,
      OptSearchArray,
      serchFormArray: [
        {
          label: "姓名",
          keyName: "name",
        },
        {
          label: "手机号",
          keyName: "phone",
        },
      ],
      textInputNumberArray: [
        {
          label: "剩余训练项<(小于)",
          keyName: "remindNumber",
        },
      ],
      checkboxInputArray: [
        {
          label: "续费提醒",
          keyName: "remember",
          type: "checkbox",
        },
      ],
      gameSaleFormArray:[
        {label: "次数", keyName:"quantity", type: "number"},
        {label: "单价", keyName:"unitPrice", type: "price"},
      ],
      addTreatmentTimeArray: [
        {
          label: "疗程个数",
          keyName: "courseCount",
          type: "number",
        },
        {
          label: "疗程个数",
          keyName: "refundCourseCount",
          type: "number",
        },
        {
          label: "疗程单价",
          keyName: "unitPrice",
          value: unitPrice,
          type: "price",
        },
        {
          label: "金额总价",
          keyName: "totalPrice",
          type: "price",
          isDisable: true,
        },
        {
          label: "退款原因",
          keyName: "note",
        },
      ],
      tabs: [
        {
          label: "购买疗程",
          key: "BUY",
          alert: "一个疗程60次训练，建议每天训练两次",
          itemList: ["courseCount", "unitPrice", "totalPrice", "salesPromotionId"],
          disabled: false,
        },
        {
          label: "退疗程",
          key: "salesReturn",
          alert: "将对疗程退款用户进行回访",
          itemList: ["refundCourseCount", "unitPrice", "totalPrice", "note"],
          disabled: false,
          disableReason: "",
        },
      ],
      resetPasswordArray: [
        {
          label: "手机号",
          keyName: "phone",
          type: "text",
          isDisable: true,
        },
        {
          label: "本账户密码",
          keyName: "password",
          type: "password",
          placeholder: "请输入您的登录密码进行验证。",
        },
        {
          label: "",
          keyName: "initFlag",
          type: "checkbox",
          children: [
            {
              label: "重置为手机后六位",
              keyName: "true",
              checked: false,
            },
          ],
        },
      ],
      resetPasswordAlert: "系统将自动生成密码并发送到用户的手机",
      addUserArray: [
        {
          label: "姓名",
          keyName: "name",
          type: "text",
        },
        {
          label: "性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE",
            },
            {
              label: "女",
              keyName: "FEMALE",
            },
          ],
        },
        {
          label: "出生年月",
          keyName: "birth",
          type: "datePicker",
        },
        {
          label: "联系人",
          keyName: "contact",
          type: "text",
        },
        {
          label: "主治医生",
          keyName: "doctorName",
          type: "text",
        },
        {
          label: "患者类型",
          keyName: "visionDisease",
          type: "select",
          children: [
            {
              label: "弱视",
              keyName: "AMBLYOPIA",
            },
            {
              label: "斜视",
              keyName: "STRABISMUS",
            },
            {
              label: "其他",
              keyName: "OTHER",
            },
          ],
        },
        {
          label: "训练阶段",
          keyName: "treatmentStage",
          type: "select",
          children: [
            {
              label: "提升期",
              keyName: "PROMOTE",
            },
            {
              label: "巩固期",
              keyName: "CONSOLIDATION",
            },
          ],
        },
        {
          label: "手机号",
          keyName: "phone",
          type: "text",
        },
        {
          label: "联系地址",
          keyName: "contactLocation",
          type: "textarea",
        },
      ],
      addingUser: false,
      resetPassword: false,
      stopAccount: false,
      deleteAccount: false,
      addTreatmentTime: false,
      gameSaleWinShowFlag: false,
      gameRefundWinShowFlag: false,
      buttonArray: [
        {
          text: "疗程管理",
          key: "addTreatmentTime",
        },
        {
          text: "重置密码",
          key: "resetAccount",
        },
        {
          text: "停用",
          key: "stopAccount",
        },
        {
          text: "删除",
          key: "deleteAccount",
        },
      ],
      buttonArray2: [
        {
          text: "重置密码",
          key: "resetAccount",
        },
        {
          text: "删除",
          key: "deleteAccount",
        },
      ],
      searchFormData: searchFormData,
      defaultValue: {},
      // startLevel: false,
      gridData: [],
      editRow: true,
      pageCount: 0,
      activePage: parseInt(activePageNumber),
      activeName: "ALL",
      checkList: [activePageTab],
      ROLE_GROUP_OPTOMETRIST,
      ROLE_AGENT_OPTOMETRIST,
      ROLE_DOCTOR,
      addUserForm: {
        name: undefined,
        gender: undefined,
        birth: undefined,
        contact: undefined,
        doctorName: undefined,
        visionDisease: undefined,
        treatmentStage: undefined,
        phone: undefined,
        contactLocation: undefined,
      },
      formLabelWidth: "100px",
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            validator: validateMobile,
            trigger: "change",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        birth: [
          {
            required: true,
            message: "请输入生日",
            trigger: "change",
          },
        ],
        visionDisease: [
          {
            required: true,
            message: "请选择患者类型",
            trigger: "change",
          },
        ],
        treatmentStage: [
          {
            required: true,
            message: "请选择训练阶段",
            trigger: "change",
          },
        ],

        unitPrice: [
          {
            required: true,
            message: "请输入疗程单价",
            trigger: "blur",
          },
        ],
        courseCount: [
          {
            required: true,
            message: "请输入疗程个数",
            trigger: "blur",
          },
        ],
      },
      importUser: false,
      importUserForm: {
        courseCount: undefined,
        unitPrice: undefined,
        totalPrice: undefined,
      },
      importUserAlertSameStation: false,
      importUserAlertNewStation: false,
      tempExistUserInfo: {},
      editPatientRemarkDialog: false,
      remakeForm: {
        note: undefined,
        patientId: undefined,
      },
      showEditIcon: false,
      hoverRow: undefined,
    };
  },
  created() {
    if (this.ROLE_DOCTOR || this.ROLE_AGENT_OPTOMETRIST) {
      this.buttonArray = [
        {
          text: "疗程管理",
          key: "addTreatmentTime",
        },
        {
          text: "单次购买",
          key: "gameSale",
        },
        {
          text: "单次退货",
          key: "gameSaleRefund",
        },
        {
          text: "重置密码",
          key: "resetAccount",
        },
        // {
        //   text: "删除",
        //   key: "deleteAccount"
        // }
      ];
    }
    if (this.stationId != null) {
      this.loadSalesPromotion();
    }
    if (this.ROLE_GROUP_OPTOMETRIST) {
      this.loadProvice();
      if (
          this.searchFormData.provinceCity &&
          this.searchFormData.provinceCity.length > 0
        ) {
          this.lodaStationList(
            this.searchFormData.provinceCity[0],
            this.searchFormData.provinceCity[1]
          );
        }
    } else {
      this.OptSearchArray.splice(0,2)
      this.OptSearchArray.push(this.activeSerachArray[3])
      this.activeSerachArray.splice(3,1)
    }
    this.loadData();
  },
  methods: {
    async loadSalesPromotion() {
      let list = await this.$http.getSalesPromotions({stationId: this.stationId});
      list.forEach((item) => {
        this.salesPromotionArr.push({label: '满' + item.condition + '赠' + item.complimentary, keyName: item.id})
      })

      this.addTreatmentTimeArray.push({
          label: "促销活动",
          keyName: "salesPromotionId",
          type: "select",
          children: this.salesPromotionArr
        })
    },
    async loadData() {
      let params = {
        page: this.activePage - 1,
      };
      for (let key in this.searchFormData) {
        if (key === "provinceCity") {
          if (this.searchFormData[key]) {
            if (this.searchFormData[key][0]) {
              params.provinceId = this.searchFormData[key][0];
            }
            if (this.searchFormData[key][1]) {
              params.districtId = this.searchFormData[key][1];
            }
          }
        } else if (key === "remember" && this.searchFormData[key]) {
          params.remindNumber = 10;
        } else if (key === "courseConfigured" && this.searchFormData[key]) {
          params.courseConfigured = false;
        } else if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }
      // console.log("params>>>>>",this.activePage, params, this.searchFormData);
      if (this.checkList[0] !== "ALL") {
        params.visionDisease = this.checkList[0];
      }
      sessionStorage.setItem(
        "patientManagementsearchFormData",
        JSON.stringify(this.searchFormData)
      );
      let data = null;
      if (this.ROLE_GROUP_OPTOMETRIST) {
        data = await this.$http.getSupervisedPatientList(params);
      } else {
        let stationId = this.stationId;
        data = await this.$http.getStationPatientList(params, stationId);
      }
      if (data && data.content) {
        let newTableData = [];
        this.pageCount = data.totalPages;
        this.totalElements = data.totalElements;
        data.content.forEach((item) => {
          newTableData.push({
            createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
            name: item.user.name,
            phone: item.user.phone,
            displayPhone: "******",
            trainingCount: `${item.finishedTrainingCount || 0}/${
              item.trainingCount || 0
            }`,
            state:
              item.finishedTrainingCount < item.trainingCount
                ? "未完成"
                : "已完成",
            remark: item.remark,
            notice: item.trainingCount - item.finishedTrainingCount <= 10,
            patientId: item.user.id,
            visionDisease: MapVisionDisease(item.visionDisease),
            leftEyeVision: MapEyeAcuityLogmar(item.leftEyeVision),
            rightEyeVision: MapEyeAcuityLogmar(item.rightEyeVision),
            courseConfigured: item.courseConfigured,
            treatmentStage: MapTreatmentStage(item.treatmentStage),
            stationUUID: item.stationUUID,
            stationName: item.stationName,
            singleGameCount: `${item.singleCount || 0}/${item.singleTotalCount || 0}`
          });
        });
        this.tableData = newTableData;
      }
    },
    onSearch(done) {
      this.activePage = 1;
      sessionStorage.setItem("activePageNumber", 1);
      // this.searchFormData = done;
      forOwn(done, (value, key) => {
        this.searchFormData[key] = done[key];
      });
      this.loadData();
    },
    async onSearchChange(data) {
      if (this.ROLE_GROUP_OPTOMETRIST) {
        if (data.provinceCity && data.provinceCity.length > 0) {
          await this.lodaStationList(data.provinceCity[0], data.provinceCity[1]);
        } else {
          this.OptSearchArray[1].children = [];
          data.stationId = undefined;
        }
      }
      forOwn(data, (value, key) => {
        this.searchFormData[key] = data[key];
      });
    },
    async onUpdateAccount(formdata, type, row) {
      let stationId = this.$cookie.get("stationId");
      if (type === "resetAccount") {
        const pwd = formdata.password;
        let result = await this.$http.checkAdminPwd(pwd);
        if (result == "success") {
          let resetResult;
          console.log('this.ROLE_GROUP_OPTOMETRIST', this.ROLE_GROUP_OPTOMETRIST, row)
          console.log("initFlag:", formdata.initFlag)
          const initFlag = formdata.initFlag && formdata.initFlag[0] === 'true' ? true : false;
          if (this.ROLE_GROUP_OPTOMETRIST) {
            const updateData = {
              patientId: row.patientId,
              resetPassword: true,
              stationUUID: row.stationUUID,
              init: initFlag,
            };
            resetResult = await this.$http.doctorUpdatePatientAcount(
              type,
              updateData
            );
          } else {
            const updateData = {
              patientId: row.patientId,
              resetPassword: true,
              stationUUID: this.stationId,
              init: initFlag,
            };
            resetResult = await this.$http.doctorUpdatePatientAcount(
              type,
              updateData
            );
          }

          if (resetResult) {
            this.$message.success("重置成功");
            this.resetPassword = false;
          }
        } else {
          this.$message.warning("密码错误，请重新输入密码");
        }
      } else if (type === "stopAccount") {
        const updateData = {
          patientId: row.patientId,
          enabled: false,
          stationUUID: this.stationId,
        };
        let result = await this.$http.doctorUpdatePatientAcount(
          type,
          updateData
        );
      } else if (type === "deleteAccount") {
        let result = await this.$http.doctorUpdatePatientAcount(type, {
          patientId: row.patientId,
          stationUUID: row.stationUUID,
        });
      } else if (type === "addAccount") {
        const updateData = cloneDeep(formdata);
        updateData.stationId = stationId;
        let result = await this.$http.addAgentOptometristPatient(updateData);
      } else if (type === "addTreatmentTime") {
        const updateData = {
          patientId: row.patientId,
          courseCount: formdata.courseCount || formdata.refundCourseCount,
          unitPrice: formdata.unitPrice,
          salesPromotionId: formdata.salesPromotionId,
          stationUUID: this.stationId,
        };
        const slectTab = formdata.slectTab;
        if (slectTab === "salesReturn") {
          updateData.remark = formdata.note;
        }
        let result = await this.$http.updatePatientPayGoods(
          updateData,
          slectTab
        );
        if (result === "success") {
          this.$message.success("提交成功");
        }
      } else if (type == "gameSale") {
        const addAGame = formdata;
        addAGame.player = row.patientId;
        addAGame.stationId = this.stationId;
        addAGame.paymentFlag = true;
        addAGame.type = 'PURCHASE';
        let result = await this.$http.saleAGame(addAGame);
        if (result == 'success') {
          this.$message.success("操作成功");
        }
      } else if (type == "gameSaleRefund") {
        const refoundGame = {};
        refoundGame.player = row.patientId;
        refoundGame.stationId = this.stationId;
        refoundGame.paymentFlag = true;
        refoundGame.type = 'REFUND';
        refoundGame.unitPrice = formdata.unitPrice;
        refoundGame.quantity = formdata.quantity;
        let result = await this.$http.saleAGame(refoundGame);
        if (result == 'success') {
          this.$message.success("操作成功");
        }
      }
      this.loadData();
      this.defaultValue = {};
    },
    async onEditGameBeginLevel() {
      const patientId = this.defaultValue.patientId;
      let data = await this.$http.editGameStartLevelList(patientId);
      data.forEach((o) => {
        o.editRow = false;
        o.formValue = o.level;
      });
      this.gridData = data;
      // this.startLevel = true;
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      switch (key) {
        case "resetAccount":
          this.resetPassword = true;
          break;
        case "stopAccount":
          this.stopAccount = true;
          break;
        case "deleteAccount":
          this.deleteAccount = true;
          break;
        // case "startLevel":
        //   this.onEditGameBeginLevel();
        //   break;
        case "addTreatmentTime":
          this.onClickEditTreatment(row);
          break;
        case "gameSale": 
          console.log("on operation click: add game");
          this.gameSaleWinShowFlag = true;
          break;
        case "gameSaleRefund":
          this.gameRefundWinShowFlag = true
          break
      }
    },
    onClickCancel(key, afterSubmit) {
      this.defaultValue = {};
      switch (key) {
        case "resetAccount":
          if (afterSubmit !== "afterSubmit") {
            this.resetPassword = false;
          }
          break;
        case "stopAccount":
          this.stopAccount = false;
          break;
        case "deleteAccount":
          this.deleteAccount = false;
          break;
        case "addTreatmentTime":
          this.addTreatmentTime = false;
          break;
        case "addingUser":
          this.addingUser = false;
          break;
        case "gameSale":
          this.gameSaleWinShowFlag = false;
          break;
        case "gameSaleRefund":
          this.gameRefundWinShowFlag = false;
          break;
      }
    },
    async loadProvice() {
      if (this.ROLE_GROUP_OPTOMETRIST) {
        let province = this.OptSearchArray;
        const ProvinceList = await this.$http.getProvinceList("optometrist");
        if (ProvinceList.length > 0) {
          const provinceChildren = ProvinceList.map(o => {
            return {
              label: o.name,
              keyName: o.id,
              value: o.id,
              children: o.sons.map(o => {
                return {
                  label: o.name,
                  value: o.id
                };
              }),
              id: o.id,
              name: o.name
            };
          });
          province.forEach(o => {
            if (o.keyName === "provinceCity") {
              o.children = provinceChildren;
            }
          });
          this.ProvinceList = provinceChildren;
        }
      }
    },
    async lodaStationList(provinceId, cityId) {
      const params = {
        provinceId,
        cityId
      };
      const StationList = await this.$http.getDoctorStationList(params);
      this.OptSearchArray[1].children = StationList.map(o => {
        return {
          keyName: o.stationUUID,
          label: o.name
        };
      });
    },
    handleCurrentChange(val) {
      this.activePage = val;
      // let hasSearch = false;
      // for (let item in this.searchFormData) {
      //   if (this.searchFormData[item]) {
      //     hasSearch = true;
      //   }
      // }
      // console.log('hasSearch????',hasSearch, val)
      // if (!hasSearch) {
      sessionStorage.setItem("activePageNumber", val);
      // }

      this.loadData();
    },
    onClick(row) {
      const stationId = row.stationUUID || this.stationId;
      this.$router.push({
        path: `${this.$route.path}/patientManagementDetail/${row.patientId}/${stationId}`,
      });
    },
    onSwitch(tabs) {
      this.checkList = [tabs];
      sessionStorage.setItem("activePageTab", tabs);
      this.activePage = 1;
      sessionStorage.setItem("activePageNumber", 1);
      this.loadData();
    },
    async onClickEditTreatment(row) {
      const refundCount = await this.$http.getPatientRefundCount(
        row.patientId,
        this.stationId
      );

      if (refundCount.count > 0) {
        let tmepArray = cloneDeep(this.addTreatmentTimeArray);
        tmepArray.forEach((o) => {
          if (o.keyName === "refundCourseCount") {
            o.max = refundCount.count;
            o.min = 1;
          }
        });
        this.addTreatmentTimeArray = tmepArray;
      } else {
        let tmepArray = cloneDeep(this.tabs);
        tmepArray.forEach((o) => {
          if (o.keyName === "salesReturn") {
            o.disabled = true;
            o.disableReason = "暂无可退疗程";
          }
        });
        this.tabs = tmepArray;
      }
      this.addTreatmentTime = true;
    },
    onAddUser() {
      this.addingUser = true;
    },
    onCancelAddUser() {
      this.addUserForm = {
        name: undefined,
        gender: undefined,
        birth: undefined,
        contact: undefined,
        doctorName: undefined,
        visionDisease: undefined,
        treatmentStage: undefined,
        phone: undefined,
        contactLocation: undefined,
      };
      this.importUserForm = {
        courseCount: undefined,
        unitPrice: undefined,
        totalPrice: undefined,
      };
      this.addingUser = false;
      this.importUserAlertSameStation = false;
      this.importUserAlertNewStation = false;
      this.importUser = false;
      this.tempExistUserInfo = {};
    },
    async checkUserPhone() {
      const phoneNumber = this.addUserForm.phone;
      const refundCount = await this.$http.checkUserPhoneNumber(phoneNumber);

      return refundCount;
    },
    onSelectChange(key) {
      if (key === "courseCount" || key === "unitPrice") {
        let tempCount = this.importUserForm.courseCount;
        if (tempCount && this.importUserForm.unitPrice) {
          this.importUserForm.totalPrice =
            tempCount * this.importUserForm.unitPrice;
        }
      }
    },
    async onAddUserConfirm() {
      if (!this.importUser) {
        this.$refs.addUserForm.validate(async (valid) => {
          if (valid) {
            const updateData = cloneDeep(this.addUserForm);
            updateData.stationId = this.stationId;
            let result = await this.$http.addAgentOptometristPatient(
              updateData
            );
            if (result === "success") {
              this.$message.success("提交成功");
            }
            this.loadData();
            this.onCancelAddUser();
          } else {
            this.$message.warning("请完成必填项");
          }
        });
      } else {
        const updateData = cloneDeep(this.importUserForm);
        updateData.stationUUID = this.stationId;
        updateData.patientId = this.tempExistUserInfo.patientId;
        let result = await this.$http.transferPatient(updateData);
        if (result === "success") {
          this.$message.success("提交成功");
        }
        this.loadData();
        this.onCancelAddUser();
      }
    },
    onEditRemark(row) {
      this.remakeForm.note = row.remark;
      this.remakeForm.patientId = row.patientId;
      this.editPatientRemarkDialog = true;
    },
    async savePatientRemark() {
      const stationId = this.stationId;
      const data = {
        stationId,
        patientId: this.remakeForm.patientId,
        remark: this.remakeForm.note,
      };
      if (this.remakeForm.patientId && this.remakeForm.note) {
        const result = await this.$http.doctorEditPatient(data);
        if (result) {
          this.$message.success("编辑成功");
          this.loadData();
          this.remakeForm = {
            note: undefined,
            patientId: undefined,
          };
        }
        this.editPatientRemarkDialog = false;
      } else {
        this.$message.warning("请填写备注后提交！");
      }
    },
    onCloseRemarkDialog() {
      this.remakeForm = {
        note: undefined,
        patientId: undefined,
      };
      this.editPatientRemarkDialog = false;
    },
    mouseenterRow(row) {
      this.hoverRow = row;
      // this.showEditIcon = true
    },
    mouseleaveRow() {
      this.hoverRow = undefined;
    },
    eyeTrainType(row) {
      return `右眼:${row.rightEyeVision || "-"}，左眼:${
        row.leftEyeVision || "-"
      }`;
    },
    showPhone(row) {
      row.displayPhone = row.phone;
    },
    hidePhone(row) {
      row.displayPhone = "******";
    },
    async onDeleteAccount(row) {
      let stationId = this.$cookie.get("stationId");
      let result = await this.$http.doctorUpdatePatientAcount("deleteAccount", {
        patientId: row.patientId,
        stationUUID: row.stationUUID,
      });
      this.loadData();
      this.defaultValue = {};
      this.deleteAccount = false;
    },
  },
};
</script>
<template>
  <div class="patientManagementIndex">
    <!-- <DialogForm
      v-if="addingUser"
      formTitle="添加患者"
      :formInputArray="addUserArray"
      @close="addingUser = false"
      @submitForm="onUpdateAccount"
      keyOperation="addAccount"
    />-->
    <DialogForm
      v-if="addTreatmentTime"
      formTitle="疗程管理"
      :formInputArray="addTreatmentTimeArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="addTreatmentTime"
      :tabs="tabs"
    />
    <DialogForm
      v-if="gameSaleWinShowFlag"
      formTitle="单次购买"
      :formInputArray="gameSaleFormArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="gameSale"
    />
    <DialogForm
      v-if="gameRefundWinShowFlag"
      formTitle="单次购买退货"
      :formInputArray="gameSaleFormArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="gameSaleRefund"
    />
    <DialogForm
      v-if="resetPassword"
      formTitle="重置密码"
      :defaultValue="defaultValue"
      :formInputArray="resetPasswordArray"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="resetAccount"
      :alertItem="resetPasswordAlert"
    />
    <DialogForm
      v-if="stopAccount"
      :defaultValue="defaultValue"
      formTitle="请确认停用账号"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="stopAccount"
      confirmButton="确认"
    />
    <!-- <DialogForm
      v-if="deleteAccount"
      :defaultValue="defaultValue"
      formTitle="请确认删除账号"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="deleteAccount"
      confirmButton="确认"
    />-->
    <elementButton
      class="addBtn"
      v-if="ROLE_DOCTOR || ROLE_AGENT_OPTOMETRIST"
      @click="onAddUser"
      >添加患者</elementButton
    >
    <Dialog
      title="创建账户"
      v-if="addingUser"
      class="DialogFormContent"
      @confirm="onAddUserConfirm"
      @close="onCancelAddUser"
      :width="importUser ? '500' : '350'"
    >
      <el-form
        v-if="!importUser"
        :model="addUserForm"
        size="small"
        class="DialogForm"
        :rules="rules"
        ref="addUserForm"
      >
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
          <el-input class="DialogInput" v-model="addUserForm.name"></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth" prop="gender">
          <el-select
            class="DialogInput"
            v-model="addUserForm.gender"
            placeholder="请选择性别"
          >
            <el-option label="男" value="MALE"></el-option>
            <el-option label="女" value="FEMALE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="出生日期"
          :label-width="formLabelWidth"
          prop="birth"
        >
          <el-date-picker
            v-model="addUserForm.birth"
            type="date"
            class="DialogInput"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth">
          <el-input
            class="DialogInput"
            v-model="addUserForm.contact"
          ></el-input>
        </el-form-item>
        <el-form-item label="主治医生" :label-width="formLabelWidth">
          <el-input
            class="DialogInput"
            v-model="addUserForm.doctorName"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
          <el-input class="DialogInput" v-model="addUserForm.phone"></el-input>
          <div class="importUserAlert" v-if="importUserAlertNewStation">
            <i class="el-icon-warning" style="color: #ff0000"></i>
            该手机号已在其他医院录入，请重
            <span class="secondLine">
              新填写或
              <span
                style="color: #00c1de; cursor: pointer"
                @click="importUser = true"
                >导入数据</span
              >
            </span>
          </div>
          <div class="importUserAlert" v-else-if="importUserAlertSameStation">
            <i class="el-icon-warning" style="color: #ff0000"></i>
            该手机号已存在，无需再次添加
          </div>
        </el-form-item>
        <el-form-item
          label="患者类别"
          :label-width="formLabelWidth"
          prop="visionDisease"
        >
          <el-select
            class="DialogInput"
            v-model="addUserForm.visionDisease"
            placeholder="请选择"
          >
            <el-option label="弱视" value="AMBLYOPIA"></el-option>
            <el-option label="斜视" value="STRABISMUS"></el-option>
            <el-option label="其他" value="OTHER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="训练阶段"
          :label-width="formLabelWidth"
          prop="treatmentStage"
        >
          <el-select
            class="DialogInput"
            v-model="addUserForm.treatmentStage"
            placeholder="请选择"
          >
            <el-option label="提升期" value="PROMOTE"></el-option>
            <el-option label="巩固期" value="CONSOLIDATION"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系地址" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            class="DialogInput"
            :rows="2"
            placeholder="请输入内容"
            v-model="addUserForm.contactLocation"
          ></el-input>
        </el-form-item>
      </el-form>
      <div v-else>
        <el-row class="existUserInfo">
          <el-col :span="12">
            <span class="existUserInfoTitle">患者姓名：</span>
            <span class="existUserInfoText">{{ tempExistUserInfo.name }}</span>
          </el-col>
          <el-col :span="12">
            <span class="existUserInfoTitle">联系人：</span>
            <span class="existUserInfoText">{{
              tempExistUserInfo.contact
            }}</span>
          </el-col>
          <el-col :span="12">
            <span class="existUserInfoTitle">主治医生：</span>
            <span class="existUserInfoText">{{
              tempExistUserInfo.doctorName
            }}</span>
          </el-col>
          <el-col :span="12">
            <span class="existUserInfoTitle">性别：</span>
            <span class="existUserInfoText">{{
              `${tempExistUserInfo.gender === "FEMALE" ? "女" : "男"}`
            }}</span>
          </el-col>
          <el-col :span="12">
            <span class="existUserInfoTitle">手机号：</span>
            <span class="existUserInfoText">{{ tempExistUserInfo.phone }}</span>
          </el-col>
          <el-col :span="12">
            <span class="existUserInfoTitle">出生年月：</span>
            <span class="existUserInfoText">{{ tempExistUserInfo.birth }}</span>
          </el-col>
          <el-col :span="12">
            <span class="existUserInfoTitle">患者类别：</span>
            <span
              class="existUserInfoText"
              v-if="tempExistUserInfo.visionDisease === 'AMBLYOPIA'"
              >弱视</span
            >
            <span
              class="existUserInfoText"
              v-else-if="tempExistUserInfo.visionDisease === 'STRABISMUS'"
              >斜视</span
            >
            <span
              class="existUserInfoText"
              v-else-if="tempExistUserInfo.visionDisease === 'OTHER'"
              >其他</span
            >
          </el-col>
          <el-col :span="12">
            <span class="existUserInfoTitle">训练阶段：</span>
            <span
              class="existUserInfoText"
              v-if="tempExistUserInfo.treatmentStage === 'PROMOTE'"
              >提升期</span
            >
            <span
              class="existUserInfoText"
              v-else-if="tempExistUserInfo.treatmentStage === 'CONSOLIDATION'"
              >巩固期</span
            >
          </el-col>
          <el-col :span="24">
            <span class="existUserInfoTitle">联系地址：</span>
            <span class="existUserInfoText">{{
              tempExistUserInfo.contactLocation
            }}</span>
          </el-col>
        </el-row>
        <div class="line"></div>
        <el-form
          :model="importUserForm"
          size="small"
          class="DialogFormImport"
          :rules="rules"
          ref="importUserForm"
        >
          <!-- <el-form-item
            label="疗程个数"
            :label-width="formLabelWidth"
            prop="courseCount"
          >
            <el-input-number
              v-model="importUserForm.courseCount"
              class="DialogInput"
              @change="onSelectChange('courseCount')"
              :min="1"
              :max="100000"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="疗程单价"
            :label-width="formLabelWidth"
            prop="unitPrice"
          >
            <el-input
              v-model="importUserForm.unitPrice"
              class="priceInput"
              autocomplete="off"
              @input="onSelectChange('unitPrice')"
            >
              <i slot="suffix" class="priceIcon">元</i>
            </el-input>
          </el-form-item>
          <el-form-item label="金额总价" :label-width="formLabelWidth">
            <div class="priceInputTotal">¥{{ importUserForm.totalPrice }}</div>
          </el-form-item> -->
        </el-form>
        <!-- <el-alert
          class="existUserDialogAlert"
          title="一个疗程60次训练，建议每天训练两次"
          type="warning"
          show-icon
          :closable="false"
        ></el-alert> -->
      </div>
    </Dialog>
    <!-- <searchForm
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      :textInputArray="searchFormArray"
      :textInputNumberArray="textInputNumberArray"
    />-->
    <searchFormNew
      class="searchFormNew"
      showSearch
      @onSearch="onSearch"
      :searchItemArray="activeSerachArray"
    />
    <searchFormNew
      class="searchFormNew"
      @onChange="onSearchChange"
      :searchItemArray="OptSearchArray"
      @onSearch="onSearch"
    />
    <div class="detailTabs">
      <div
        class="tab-cell"
        @click="onSwitch('ALL')"
        :style="{
          'border-bottom': `${
            checkList.indexOf('ALL') > -1
              ? '2px solid #00c1de'
              : '1px solid #ffffff'
          }`,
          color: `${checkList.indexOf('ALL') > -1 ? '#00c1de' : '#595959'}`,
        }"
      >
        全部
      </div>
      <div
        class="tab-cell"
        @click="onSwitch('AMBLYOPIA')"
        :style="{
          'border-bottom': `${
            checkList.indexOf('AMBLYOPIA') > -1
              ? '2px solid #00c1de'
              : '1px solid #ffffff'
          }`,
          color: `${
            checkList.indexOf('AMBLYOPIA') > -1 ? '#00c1de' : '#595959'
          }`,
        }"
      >
        弱视
      </div>
      <div
        class="tab-cell"
        @click="onSwitch('STRABISMUS')"
        :style="{
          'border-bottom': `${
            checkList.indexOf('STRABISMUS') > -1
              ? '2px solid #00c1de'
              : '1px solid #ffffff'
          }`,
          color: `${
            checkList.indexOf('STRABISMUS') > -1 ? '#00c1de' : '#595959'
          }`,
        }"
      >
        斜视
      </div>
      <div
        class="tab-cell"
        @click="onSwitch('OTHER')"
        :style="{
          'border-bottom': `${
            checkList.indexOf('OTHER') > -1
              ? '2px solid #00c1de'
              : '1px solid #ffffff'
          }`,
          color: `${checkList.indexOf('OTHER') > -1 ? '#00c1de' : '#595959'}`,
        }"
      >
        其他
      </div>
    </div>
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{ totalElements }}</span> 个
    </div>
    <el-table
      :data="tableData"
      class="accountTable"
      @row-click="onClick"
      :header-cell-style="{
        'padding-left': '4px',
        color: 'rgba(0,0,0,0.65)',
        'font-size': '14px',
        'background-color': '#fafafa !important',
      }"
      :cell-style="{ 'padding-left': '4px' }"
      @cell-mouse-enter="showPhone"
      @cell-mouse-leave="hidePhone"
    >
      <el-table-column prop="label" align="left" label width="75">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.notice" size="mini" type="danger"
            >建议充值</el-tag
          >
          <el-tag
            v-if="scope.row.courseConfigured === false"
            size="mini"
            type="danger"
            >待配置</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        align="left"
        label="创建时间"
        width="105"
      ></el-table-column>
      <!-- <el-table-column prop="name" align="left" label="姓名" width="100"></el-table-column> -->
      <el-table-column
        prop="displayPhone"
        align="left"
        label="患者信息"
        width="200"
      >
        <template slot-scope="scope">
          <!-- <span>{{scope.row.displayPhone}}</span> -->
          <div>
            <div>
              {{ scope.row.name }}
              <span style="float: right">{{ scope.row.displayPhone }}</span>
            </div>
            <div>{{ scope.row.stationName }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="trainingCount"
        align="left"
        label="训练项"
        width="80"
      ></el-table-column>
      <el-table-column prop="singleGameCount" label="单次训练" width="80"></el-table-column>
      <el-table-column prop="label" align="left" label="矫正视力" width="85">
        <template slot-scope="scope">
          <div>
            <div>右眼:{{ scope.row.rightEyeVision }}</div>
            <div>左眼:{{ scope.row.leftEyeVision }}</div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="state" align="left" label="状态" width="80"></el-table-column> -->
      <el-table-column
        prop="visionDisease"
        align="left"
        label="类型"
        width="55"
      ></el-table-column>
      <el-table-column
        prop="treatmentStage"
        align="left"
        label="训练阶段"
        width="90"
      ></el-table-column>
      <el-table-column prop="remark" align="left" label="备注" min-width="115">
        <template slot-scope="scope">
          <span
            class="patientRemark"
            @mouseenter="mouseenterRow(scope.row)"
            @mouseleave="mouseleaveRow"
            @click.stop="onEditRemark(scope.row)"
          >
            {{ scope.row.remark }}
            <i
              v-if="hoverRow && hoverRow.patientId === scope.row.patientId"
              class="el-icon-edit"
            />
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operation"
        align="left"
        label="操作"
        v-if="ROLE_GROUP_OPTOMETRIST"
        :width="200"
      >
        <template slot-scope="scope">
          <textButtonGroup
            :buttonArray="buttonArray2"
            :rowData="scope.row"
            @onOperationClick="onOperationClick"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="operation"
        align="left"
        label="操作"
        v-else-if="ROLE_AGENT_OPTOMETRIST || ROLE_DOCTOR"
        :width="ROLE_AGENT_OPTOMETRIST || ROLE_DOCTOR ? 220 : 275"
      >
        <template slot-scope="scope">
          <textButtonGroup
            :buttonArray="buttonArray"
            :rowData="scope.row"
            @onOperationClick="onOperationClick"
          />
        </template>
      </el-table-column>
    </el-table>
    <operationDialog
      title="患者备注"
      :center="true"
      width="500px"
      custom-class="customClass"
      :Visible="editPatientRemarkDialog"
      @close="onCloseRemarkDialog"
      @confirm="savePatientRemark"
      btnText="保存"
    >
      <el-form :model="remakeForm">
        <el-form-item>
          <el-input
            type="textarea"
            v-model="remakeForm.note"
            :rows="3"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button class="saveRemarkButton" @click="savePatientRemark">保存</el-button>
      </div>-->
    </operationDialog>
    <el-dialog
      title="警告信息"
      :visible.sync="deleteAccount"
      width="658px"
      top="200px"
      class="quitConfirmDialog"
      :modal-append-to-body="false"
    >
      <div class="content">
        <div class="title">删除患者账号是不可逆操作！</div>
        <div class="cell">账号一经删除，疗程将会被消耗，无法找回。</div>
        <div class="cell">如有剩余疗程请先进行疗程回收，再进行删除。</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="confirmBtn" @click="deleteAccount = false"
          >取消</el-button
        >
        <el-button class="cancelBtn" @click="onDeleteAccount(defaultValue)"
          >确定删除</el-button
        >
      </span>
    </el-dialog>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>


<style lang="scss">
@import "@/css/color.scss";

.patientManagementIndex {
  .searchFormNew {
    border: 1px;
    height: 50px;
    margin: 0 2%;
    padding-top: 10px;
    .radioStyle {
      width: 260px;
      .el-form-item__content {
        line-height: 36px;
      }
      .el-form-item__label {
        line-height: 36px;
      }
      .childrenItem {
        min-width: 150px;
      }
    }
  }

  .patientManagementDialog {
    border-radius: 12px;

    .patientManagementDialogTable {
      max-height: 400px;
      overflow-y: scroll;

      .editLevelSpan {
        cursor: pointer;
        min-width: 200px;

        .editIcon {
          margin-left: 5px;
          color: #00c1de;
        }
      }

      .editRowLevel {
        display: inline-block;

        .numberInput {
          width: 80px;
        }

        .editButton {
          background-color: #00c1de;
          border-color: #00c1de;
          color: #fff;
        }

        .cancelButton {
        }
      }
    }
  }
  .DialogFormContent {
    .DialogForm {
      .DialogInput {
        margin-left: 21px;
        margin-right: 21px;
        width: 82% !important;
        line-height: 37px;

        .el-radio__input.is-checked .el-radio__inner {
          border-color: #00c1de;
          background-color: #fff;
        }

        .el-radio__inner::after {
          background-color: #00c1de;
        }

        .el-radio__input.is-checked + .el-radio__label {
          color: #00c1de;
        }

        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #00c1de;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          border-color: #00c1de;
          background-color: #00c1de;
        }

        .el-input.is-active .el-input__inner,
        .el-input__inner:focus {
          border-color: #00c1de;
        }

        .el-input.is-active .el-input__inner,
        .el-input__inner:hover {
          border-color: #00c1de;
        }

        .el-form-item__error {
          left: 25px;
        }

        .el-form-item--small .el-form-item__error {
          left: 25px;
        }
        .el-input-number__decrease {
          height: 30px;
          line-height: 30px;
          margin-top: 3px;
        }
        .el-input-number__increase {
          line-height: 30px;
          margin-top: 3px;
          height: 30px;
        }
        .priceInput {
          width: 100%;
          // margin-right: 10px;
        }

        .switchInput {
          margin-left: 2px;
          margin-right: 10px;
        }

        .priceIcon {
          margin-right: 5px;
        }

        .priceInputTotal {
          width: 97%;
          font-size: 20px;
          margin: auto;
        }
      }
      .importUserAlert {
        margin-left: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        line-height: 17px;
        width: 205px;
        .secondLine {
          display: block;
          margin-left: 16px;
        }
      }
      .el-form-item__error {
        left: 25px;
      }

      .dialogInputNumber {
        .el-input__inner {
          padding-right: 10px;
        }
      }

      .el-form-item {
        margin-bottom: 12px;
      }

      margin: 20px 0px 15px;
    }

    .DialogAlert {
      margin: 15px auto;
      width: 306px;
      padding-left: 10px;
      height: 36px;
      background: rgba(255, 251, 230, 1);
      border-radius: 4px;
      border: 1px solid rgba(255, 229, 143, 1);

      .el-alert__title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
      }
    }

    .existUserInfo {
      width: 90%;
      margin-left: 50px;

      // margin-right: auto;
      .el-col {
        margin-bottom: 15px;
      }
      .existUserInfoTitle {
        display: inline-block;
        width: 80px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
      }
      .existUserInfoText {
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
      }
    }
    .DialogFormImport {
      .DialogInput {
        margin-left: 21px;
        margin-right: 21px;
        width: 150px !important;
        line-height: 37px;
        .el-input.is-active .el-input__inner,
        .el-input__inner:focus {
          border-color: #00c1de;
        }

        .el-input.is-active .el-input__inner,
        .el-input__inner:hover {
          border-color: #00c1de;
        }

        .el-form-item__error {
          left: 25px;
        }

        .el-form-item--small .el-form-item__error {
          left: 25px;
        }
        .el-input-number__decrease {
          height: 30px;
          line-height: 30px;
          margin-top: 3px;
        }
        .el-input-number__increase {
          line-height: 30px;
          margin-top: 3px;
          height: 30px;
        }
      }
      .priceInput {
        width: 150px;
        margin-left: 21px;
        // margin-right: 10px;
      }

      .priceIcon {
        margin-right: 5px;
      }

      .priceInputTotal {
        width: 250px;
        font-size: 20px;
        margin-left: 21px;
        margin: auto;
      }
      .el-form-item__error {
        left: 25px;
      }

      .dialogInputNumber {
        .el-input__inner {
          padding-right: 10px;
        }
      }
      width: 75%;
      margin: 20px 0px 15px 20px;
    }
    .line {
      width: 400px;
      height: 1px;
      background-color: #e4e8eb;
      margin-left: 50px;
    }
    .existUserDialogAlert {
      margin: 15px 30px 15px 50px;
      width: 306px;
      padding-left: 10px;
      height: 36px;
      background: rgba(255, 251, 230, 1);
      border-radius: 4px;
      border: 1px solid rgba(255, 229, 143, 1);

      .el-alert__title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
      }
    }
  }

  .detailTabs {
    background-color: #ffffff;
    margin-left: 2%;
    width: 75%;
    display: inline-block;
    .tab-cell {
      display: inline-block;
      padding: 20px 0;
      text-align: center;
      width: 80px;
      cursor: pointer;
    }
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }

  .accountTable {
    margin: auto;
    border: 1px;
    width: 98%;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    th > .cell {
      font-weight: bold;
    }
    // .patientListHeaderCell {
    //   > .cell {
    //     padding-left: 0px;
    //     padding-right: 0px;
    //   }
    // }
    // .patientListBodyCell {
    //   > .cell {
    //     padding-left: 0px;
    //     padding-right: 0px;
    //   }
    // }
  }
  .patientRemark {
    cursor: pointer;
    display: inline-block;
    width: 100%;
    min-height: 20px;
    > i {
      margin-left: 10px;
      color: #00c1de;
    }
  }
  .patientNoneRemark {
    display: none;
  }
  .patientNoneRemark:hover {
    display: inline-block;
  }
  .addBtn {
    width: 83px;
    height: 35px;
    margin-top: 20px;
    border-radius: 3px;
    float: right;
    margin-right: 3%;
    padding: 3px;
    border-color: #00c1de;
  }
  .saveRemarkButton {
    border-color: #00c1de;
    background-color: #00c1de;
    color: #ffffff;
    width: 100px;
  }
  .quitConfirmDialog {
    // border-radius: 12px;
    .el-dialog {
      border-radius: 12px;

      .el-dialog__header {
        line-height: 56px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        padding: 0;
        background-color: #e33535;
        background-image: url("../../assets/errorIcon.png");
        background-repeat: no-repeat;
        background-size: 30px 27px;
        background-position: 10px;

        .el-dialog__title {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 25px;
          margin-left: 50px;
        }

        .el-dialog__headerbtn {
          display: none;
        }
      }

      .content {
        margin: 10px 30px;
        margin-left: 70px;

        .title {
          font-size: 25px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(52, 52, 52, 1);
          line-height: 36px;
        }

        .cell {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(130, 130, 130, 1);
          line-height: 25px;
        }
      }

      .el-dialog__footer {
        // text-align: left;
        padding: 0px 160px 80px;
        .confirmBtn {
          width: 150px;
          height: 45px;
          float: left;
          background-color: #57aa13;
          border-color: #57aa13;
          color: #ffffff;
          border-radius: 0;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }

        .cancelBtn {
          width: 150px;
          height: 45px;
          float: right;
          // margin-left: 20px;
          background-color: #e33535;
          border-color: #e33535;
          color: #ffffff;
          border-radius: 0;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/patientManagement/index.vue